import React from 'react'
import SettingsIntermediate from '../SettingsIntermediate'
import userPermissions from '../../User/Permissions';
import { getSession } from '../../../auth';
import Integrations from '../../Settings/Integrations';
import ExternalIntegrations from '../../Settings/Integrations/external';
import KwikApiKey from '../../Settings/Integrations/kwik-api-key';
import { Box, Alert } from '@mui/material';
import Settings from '../../Scout/Pages/settings-page'
import AdvancedConfigs from '../../Scout/Pages/advancedconfs-page';
import RestrictedWordsComponent from '../../Settings/RestrictedWords';
import ProductsAndServicesPage from '../../Scout/products-page';
import ScoutCrmIntegration from '../../Scout/Pages/CrmIntegration';
import CategoriesPage from '../../Scout/categories-page';

const ScoutPage = () => {
    const groups = userPermissions();
    const enterprise = getSession()?.profile?.enterprise
    return (
        <>
            {enterprise.platforms.scout ? <SettingsIntermediate title='Scout' components={() => ({
                comp1: {
                    permissions: true,
                    style: 'title',
                    label: 'Scout'
                },
                comp2: {
                    permissions: groups.isAdmin,
                    style: 'list',
                    label: 'Gestão de telefones',
                    sublabel: 'Verifique informações, ou ajuste os telefones cadastrados.',
                    redirect: (<Settings />),
                    isVisible: true
                },
                comp3: {
                    permissions: groups.isAdmin,
                    style: 'list',
                    label: 'Configurações avançadas',
                    sublabel: 'Configure exportação automática de conversas.',
                    redirect: (<AdvancedConfigs />)
                },
                comp4: {
                    permissions: groups.isAdmin,
                    style: 'list',
                    label: 'Palavras restritas',
                    sublabel: 'Configure palavras que serão destacadas nas conversas.',
                    redirect: (<RestrictedWordsComponent enterpriseId={enterprise?.id} scout={1}/>)
                }, 
                comp5: {
                    permissions: groups.isAdmin,
                    style: 'list',
                    label: 'Produtos e Serviços',
                    sublabel: 'Configure seus produtos e serviços para geração de métricas com Inteligência Artifical.',
                    redirect: (<ProductsAndServicesPage />)
                },
                comp6: {
                    permissions: groups.isAdmin,
                    style: 'list',
                    label: 'Integrações',
                    sublabel: 'Configure integrações com CRMs externos.',
                    redirect: (<ScoutCrmIntegration />)
                },
                comp7: {
                    permissions: groups.isAdmin,
                    style: 'list',
                    label: 'Categorias',
                    sublabel: 'Configure as categorias dos seus contatos para que a nossa Inteligência Artificial os organize automaticamente.',
                    redirect: (<CategoriesPage />)
                }
            })
            } />
                :
                <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Box sx={{ fontSize: "1.5em", fontWeight: "bold", color: "#21446c" }}>Scout</Box>
                    <Alert severity="info">
                        Entre em contato com seu gerente de contas para contratar o Kwik Scout - O canal de "Compliance"  e gravacao de WhatsApp do Kwik - <a href="https://wa.link/0bs73j">Clique aqui.</a>
                    </Alert>
                </Box>
            }
        </>
    )
}

export default ScoutPage
